import React from 'react';
import { Footer } from '../components';

export function FooterContainer() {
   return (
      <Footer>
         {/* <Footer.Title>Questions? Call 0808 196 5391 </Footer.Title> */}
         {/* <Footer.Break/> */}

         <Footer.Row>
           <Footer.Column>
              
               <Footer.Link href="#">FAQ</Footer.Link>
               {/* <Footer.Link href="#">Investor Relations</Footer.Link> */}
               {/* <Footer.Link href="#">Ways to Watch</Footer.Link>
               <Footer.Link href="#">Corporate Information</Footer.Link>
            </Footer.Column>
            <Footer.Column>
               <Footer.Link href="#">Help Centre</Footer.Link>
               <Footer.Link href="#">Jobs</Footer.Link>
               <Footer.Link href="#">Terms of Use</Footer.Link>
               <Footer.Link href="#">Contact US</Footer.Link>
            </Footer.Column>
            <Footer.Column>
               <Footer.Link href="#">Account</Footer.Link>
               <Footer.Link href="#">Redeen gift cards</Footer.Link>
               <Footer.Link href="#">Privacy</Footer.Link>
               <Footer.Link href="#">UK Modern Slavery Act</Footer.Link>
            </Footer.Column>

            <Footer.Column>
            <Footer.Link href="#">Media Centre</Footer.Link>
            <Footer.Link href="#">Buy Gift Cards</Footer.Link> */} </Footer.Column>

<Footer.Column>            <Footer.Link href="#">Cookie Preferences</Footer.Link>
</Footer.Column>
<Footer.Column>
            <Footer.Link href="https://fast.com/">Speed Test</Footer.Link>

            </Footer.Column>            
         <Footer.Column>
            <Footer.Link href="https://xerohero.dev">XeroHero.dev</Footer.Link>
         </Footer.Column>
         </Footer.Row>
      </Footer>
      );
}